import { render, staticRenderFns } from "./baseStartEvent.vue?vue&type=template&id=1aff2df2&"
import script from "./baseStartEvent.vue?vue&type=script&lang=js&"
export * from "./baseStartEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports